/**
 * @author (original) alteredq / http://alteredqualia.com/
 * @author (ES version) teel
 *
 * Full-screen textured quad shader
 */
const CopyShader = {
	uniforms: {
		tDiffuse: { value: null },
		opacity:  { value: 1.0 }
	},
	vertexShader: require('./CopyShader.vert'),
	fragmentShader: require('./CopyShader.frag'),
};

export default CopyShader;
